/** Common tool-tag labels for zh-CN cards (slug / English → short Chinese). */
const TAG_ZH: Record<string, string> = {
  chatbot: '对话',
  productivity: '效率',
  'video-creation': '视频',
  'audio-speech': '语音',
  'image-generation': '图像',
  'image-editing': '修图',
  'code-assistant': '编程',
  coding: '编程',
  writing: '写作',
  'writing-assistant': '写作',
  marketing: '营销',
  design: '设计',
  research: '检索',
  education: '学习',
  assistant: '助手',
  'ai-assistant': '助手',
  freemium: '免费增值',
  free: '免费',
  paid: '付费',
  agent: '智能体',
  automation: '自动化',
  voice: '语音',
  video: '视频',
  image: '图像',
  music: '音乐',
  chat: '对话',
  llm: '大模型',
  openai: 'OpenAI',
  google: 'Google',
  microsoft: '微软',
};

const JUNK = new Set([
  'aicpb', 'aigc', 'sitemap', 'discover', 'catalog', 'topai', 'ai', 'seed',
]);

function normalizeTag(raw: string): string {
  return String(raw || '').trim().replace(/^#/, '');
}

/** Parse tool.tags JSON/text into clean display labels for the current language. */
export function getDisplayTags(
  raw: string | string[] | null | undefined,
  language: string,
  limit = 3,
): string[] {
  let tags: string[] = [];
  if (Array.isArray(raw)) {
    tags = raw.map((t) => normalizeTag(String(t)));
  } else if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) tags = parsed.map((t) => normalizeTag(String(t)));
      else tags = raw.split(/[,，]/).map(normalizeTag);
    } catch {
      tags = raw.split(/[,，]/).map(normalizeTag);
    }
  }

  const out: string[] = [];
  const seen = new Set<string>();
  for (const tag of tags) {
    if (!tag || tag.length > 24) continue;
    const lower = tag.toLowerCase();
    if (lower.startsWith('seed-') || JUNK.has(lower)) continue;

    let label = tag;
    if (language === 'zh-CN') {
      const mapped =
        TAG_ZH[lower] ||
        TAG_ZH[lower.replace(/_/g, '-')] ||
        TAG_ZH[lower.replace(/\s+/g, '-')] ||
        TAG_ZH[lower.replace(/\s+/g, '')];
      if (mapped) {
        label = mapped;
      } else if (/^[a-z0-9][a-z0-9 ._-]{1,}$/i.test(tag) && !/[\u4e00-\u9fff]/.test(tag)) {
        // Hide leftover English slug/phrase tags on CN — category chip already covers intent.
        continue;
      }
    }

    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
    if (out.length >= limit) break;
  }
  return out;
}
